import React, { RefObject } from 'react';

import { getTimelineViewportRange } from './get-timeline-viewport-range';
import * as Styled from './goal-timeline.style';
import { PositionedTimelineColumn } from './types';
import { useTimelineScrollLeft } from './use-timeline-scroll-left';

export type TimelineHeaderColumnsProps = {
  columns: PositionedTimelineColumn[];
  scrollRef: RefObject<HTMLDivElement>;
  viewportWidth: number;
  syncTo: number;
};

// Header labels virtualized the same way as the grid background: only the column
// headers within the visible window are rendered, tracking the body's scroll.
export const TimelineHeaderColumns: React.FC<TimelineHeaderColumnsProps> =
  React.memo(({ columns, scrollRef, viewportWidth, syncTo }) => {
    const scrollLeft = useTimelineScrollLeft(scrollRef, syncTo);
    const { start, end } = getTimelineViewportRange(
      scrollLeft,
      viewportWidth,
      viewportWidth,
    );

    const visibleColumns = columns.filter(
      (column) => column.left < end && column.left + column.width > start,
    );

    return (
      <Styled.MonthsHeaderContainer>
        {visibleColumns.map((column) => (
          <Styled.MonthHeader
            key={column.key}
            $left={column.left}
            $width={column.width}
            $isStartOfYear={column.isStartOfYear}
          >
            {column.label}
          </Styled.MonthHeader>
        ))}
      </Styled.MonthsHeaderContainer>
    );
  });
